// extracted by mini-css-extract-plugin
export default {"kycHome_container":"KYCHomeScreen_kycHome_container__9bt2A","spacer":"KYCHomeScreen_spacer__tTw-0"};